// extracted by mini-css-extract-plugin
export default {"box":"styles_box__xzIM7","content":"styles_content__6nU8W","title":"styles_title__ROIRS","bold_txt":"styles_bold_txt__4jXBb"};